import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { ResponsiveTableModule } from '@fantaz/shared/directives/responsive-table';
import { SharedPipesModule } from '@fantaz/shared/pipes';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { EmptyListModule } from '@fantaz/shared/ui/empty-list';
import { SharedUiLoadingComponentModule } from '@fantaz/shared/ui/loading-component';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { TournamentsUiFilterModule } from '@fantaz/tournaments-v2/ui/filters';
import { PlayButtonModule } from '@fantaz/tournaments/ui/play-button';
import { SharedTableComponentComponent } from './shared-table-component/shared-table-component.component';

@NgModule({
  imports: [
    CommonModule,
    EmptyListModule,
    ResponsiveTableModule,
    OverlayModule,
    SharedPipesModule,
    CurrencyModule,
    SharedUiLoadingComponentModule,
    TournamentsUiFilterModule,
    SharedPipesDateModule,
    PlayButtonModule,
    MaterialModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  declarations: [SharedTableComponentComponent],
  exports: [SharedTableComponentComponent],
  providers: [
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        formFieldAppearance: 'fill',
      },
    },
  ],
})
export class SharedUiTableComponentModule {}
